import defaultApi from './defaultApi';
import { scpmUtil } from '@/utils/scpmUtil.js';

const systemApi = {
  system: {
    prefix:
      process.env.VUE_APP_PROXY + process.env.VUE_APP_PUBLIC_PATH + '/cloudmonitorings/system',
    SWAGGER: '/v2/api-docs?group=API-v1.0.0',
    API_INFO: {
      '/api/roles': {},
      '/api/roles/{roleId}': {
        get: {
          pathParam: {
            roleId: 'MANAGER' //Available values : MANAGER, OPERATOR, QA, SYS_ADMIN, TYPE_ADMIN
          }
        }
      },
      '/api/roles/{userSq}': {
        get: {
          use_sample: true,
          desc: '정상적인 userSq 를 알아내야함',
          test: false
        }
      },
      '/v1/console/commoncodes': {
        get: {
          desc: '정상동작 확인함'
        },
        post: {
          desc: '정상동작 확인함'
        }
      },
      '/v1/console/commoncodes/parentCode/{code}': {
        get: {
          pathParam: { code: 6 }
        }
      },
      '/v1/console/commoncodes/{id}': {},
      '/v1/console/commoncodes/{sq}': {
        get: {
          pathParam: { sq: 5 },
          sampleParam: { id: 1 },
          desc: '정상적으로 응답 내려오고 있지만 {sq}의 의미는 없는것으로 보임'
        }
      },
      '/v1/console/iams/check-authorization': {},
      '/v1/console/menus': {
        get: {
          use_sample: false,
          use_mock: false,
          desc: '데이터가 내려오지 않음(12/30) 데이터는 맞춰야 함 (imgName, url, 메뉴이름과 순서도 맞춰야 함, Home도 내려와야 하는지 문의 해야함)',
          test: true
        }
      },
      '/v1/console/projects': {
        get: {
          test: true
        }
      },
      '/v1/console/projects/check-/v2/check-authorization': {},
      '/v1/console/tags': {},
      '/v1/console/tags/resources': {},
      '/v1/console/tags/resources/{resourceId}': {},
      '/v1/console/users/account-histories': {
        post: {
          test: true
        }
      }
    },
    SAMPLE: {
      '/v1/console/menus': {
        contents: [
          {
            imgName: 'lnb_dashboard',
            menuNm: '모니터링대시보드',
            menuOrder: 1,
            menuSq: 1,
            parentMenuSq: 0,
            url: '/dashboard'
          },
          {
            imgName: 'lnb_perfermance',
            menuNm: '성능분석',
            menuOrder: 2,
            menuSq: 2,
            parentMenuSq: 0,
            url: '/performanceList'
          },
          {
            imgName: 'lnb_log',
            menuNm: '로그 분석',
            menuOrder: 3,
            menuSq: 3,
            parentMenuSq: 0,
            url: ''
          },
          {
            imgName: '',
            menuNm: '로그수집대시보드',
            menuOrder: 1,
            menuSq: 31,
            parentMenuSq: 3,
            url: '/logs/logDashboard'
          },
          {
            imgName: '',
            menuNm: '로그현황',
            menuOrder: 2,
            menuSq: 32,
            parentMenuSq: 3,
            url: '/logs/logCollections'
          },
          {
            imgName: '',
            menuNm: '로그 분석',
            menuOrder: 3,
            menuSq: 33,
            parentMenuSq: 3,
            url: '/logs/logMetricManage'
          },
          {
            imgName: 'lnb_event',
            menuNm: '이벤트관리',
            menuOrder: 4,
            menuSq: 4,
            parentMenuSq: 0,
            url: ''
          },
          {
            imgName: '',
            menuNm: '이벤트현황',
            menuOrder: 1,
            menuSq: 41,
            parentMenuSq: 4,
            url: '/event/eventStatus'
          },
          {
            imgName: '',
            menuNm: '이벤트설정',
            menuOrder: 2,
            menuSq: 42,
            parentMenuSq: 4,
            url: '/event/eventSettings'
          },
          {
            imgName: '',
            menuNm: 'ㄴ이벤트추가',
            menuOrder: 3,
            menuSq: 43,
            parentMenuSq: 4,
            url: '/event/eventAdd'
          },
          {
            imgName: '',
            menuNm: 'ㄴ이벤트수정',
            menuOrder: 4,
            menuSq: 44,
            parentMenuSq: 4,
            url: '/event/eventEdit'
          },
          {
            imgName: '',
            menuNm: 'ㄴ이벤트상세',
            menuOrder: 10,
            menuSq: 50,
            parentMenuSq: 4,
            url: '/event/eventDetail'
          },
          {
            imgName: '',
            menuNm: 'ㄴ템플릿추가',
            menuOrder: 5,
            menuSq: 45,
            parentMenuSq: 4,
            url: '/event/addTemplate'
          },
          {
            imgName: '',
            menuNm: 'ㄴ템플릿수정',
            menuOrder: 8,
            menuSq: 48,
            parentMenuSq: 4,
            url: '/event/editTemplate'
          },
          {
            imgName: '',
            menuNm: 'ㄴ템플릿상세',
            menuOrder: 9,
            menuSq: 49,
            parentMenuSq: 4,
            url: '/event/detailemplate'
          },
          {
            imgName: '',
            menuNm: '이벤트필터링',
            menuOrder: 6,
            menuSq: 46,
            parentMenuSq: 4,
            url: '/event/eventFilter'
          },
          {
            imgName: '',
            menuNm: '알림주소록',
            menuOrder: 7,
            menuSq: 47,
            parentMenuSq: 4,
            url: '/event/alarmAddrs'
          },
          {
            imgName: 'lnb_agent',
            menuNm: '에이전트관리',
            menuOrder: 5,
            menuSq: 5,
            parentMenuSq: 0,
            url: '/agentManage'
          },
          { imgName: '', menuNm: 'HOME', menuOrder: 1, menuSq: 0, parentMenuSq: null, url: '' }
        ],
        totalCount: 100
      }
    },
    getProductTags(params, productTypeCode) {
      return new Promise((resolve, reject) => {
        this.get('/v1/console/tags', params, true, true, {
          headers: { 'X-ResourceType': productTypeCode }
        })
          .then((data) => {
            let productTagItems = [];
            if (Object.keys(data).length > 0) {
              data.contents.forEach((item) => {
                productTagItems.push({ key: item.tagKey, text: scpmUtil.getTagText(item) });
              });
            }
            resolve(productTagItems);
          })
          .catch((err) => reject(err));
      });
    },
    getListASG(param) {
      return new Promise((resolve, reject) => {
        this.get('/v1/console/groups', param)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => reject(err));
      });
    }
  }
};
systemApi.system = Object.assign(systemApi.system, defaultApi);
export default systemApi;
